module.exports = __webpack_public_path__ + "static/logo-4a7ff152a16225502ccb951ac043facc.png";